// Copyright © Orpyx® Medical Technologies Inc. 2026. All rights reserved.
// **ORPYX TRADE SECRET**
// **WARNING**: The contents of this repository, including source code and assets, are confidential. This source code and/or derived works are a trade secret of Orpyx Medical Technologies Inc. Unauthorized disclosure is strictly prohibited and may result in serious legal consequences.

import {makeStyles} from "@material-ui/styles";
import {createStyles} from "@material-ui/core";
import { Teal } from "orpyx-web-common";

export const usePatientSubmitCareNoteFormStyles = makeStyles(() => createStyles({
    title: {
        marginTop: '0',
        fontSize: '20px',
        color: Teal,
    },
    withinLimitsDiv: {
        height: "60px",
        textAlign: "center",
    },
    withinLimitsButton: {
        // Royal Blue
        backgroundColor: '#256CD7',
        height: "65%",
        width: "60%",
        '&:hover': {
            // Dark Blue
            backgroundColor: '#093F57',
        },
    },
}));
